import React from 'react'
import { Browser } from '@syncfusion/ej2-base'
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  ColumnSeries,
  Category,
  Legend,
  Tooltip,
  DataLabel,
  AxisModel,
  LegendSettingsModel,
} from '@syncfusion/ej2-react-charts'
import { ChartSeriesData } from '@dataTypes/dashboard.types'
import '../DashboardStyle.css'

type ColumnChartProps = {
  title: string
  data: ChartSeriesData[]
  seriesNames: string[]
  colors: string[]
  yAxisSettings?: AxisModel
  xAxisSettings?: AxisModel
  legendSettings?: LegendSettingsModel
  chartHeight?: string
  chartWidth?: string
  maximum?: number
  minimun?: number
  interval?: number
}
const ColumnChart = ({
  title,
  data,
  seriesNames,
  colors,
  yAxisSettings,
  xAxisSettings,
  legendSettings,
  chartHeight,
  chartWidth,
  maximum,
  minimun,
  interval,
}: ColumnChartProps): React.ReactElement => {
  const defaultYAxisSettings: AxisModel = {
    title: '',
    majorGridLines: { width: 1 },
    majorTickLines: { width: 0 },
    lineStyle: { width: 0 },
    maximum: maximum ?? 65,
    minimum: minimun ?? 40,
    interval: interval ?? 5,
  }

  const defaultXAxistSettings: AxisModel = {
    labelIntersectAction: Browser.isDevice ? 'None' : 'Trim',
    labelRotation: Browser.isDevice ? -45 : 0,
    valueType: 'Category',
    interval: 1,
    majorGridLines: { width: 1 },
    majorTickLines: { width: 0 },
  }

  const defaultLegendSettings: LegendSettingsModel = {
    visible: true,
    position: 'Top',
    alignment: 'Near',
  }
  return (
    <div className="dashboard-control-pane" key={title}>
      <div className="dashboard-control-section">
        <ChartComponent
          id={title}
          style={{ textAlign: 'center' }}
          legendSettings={legendSettings ?? defaultLegendSettings}
          primaryXAxis={xAxisSettings ?? defaultXAxistSettings}
          primaryYAxis={yAxisSettings ?? defaultYAxisSettings}
          tooltip={{
            enable: true,
            header: '<b>${point.tooltip}</b>',
            shared: true,
          }}
          width={chartWidth ?? '100%'}
          height={chartHeight ?? '300'}
        >
          <Inject
            services={[ColumnSeries, Category, Legend, Tooltip, DataLabel]}
          />
          <SeriesCollectionDirective>
            {seriesNames.map((name, index) => (
              <SeriesDirective
                key={name}
                dataSource={data}
                tooltipMappingName={'xValue'}
                xName="xValue"
                yName={name}
                name={name}
                type="Column"
                legendShape="Circle"
                fill={colors[index]}
              />
            ))}
          </SeriesCollectionDirective>
        </ChartComponent>
      </div>
    </div>
  )
}

export default ColumnChart
